import React from "react";
import { useLoaderData } from "react-router-dom";
import Quiz from "../Quiz/Quiz";
import "./ReactQuiz.css";

const ReactQuiz = () => {
  const items = useLoaderData();

  const { logo, name } = items.data;

  return (
    <div className="bg-slate-200">
      <div className="flex flex-col justify-center items-center text-center text-2xl font-bold bg-slate-900 text-white  relative top-4 w-40 mx-auto rounded-lg  drop-shadow quiz-topic">
        <p className="text-center text-lg font-bold mt-2 quiz-name">
          {name} Quiz
        </p>
        <img className="w-8 mb-2" src={logo} alt="" />
      </div>

      {items.data.questions.map((question) => (
        <div>
          <div className="border border-sky-400 rounded-lg p-8 w-3/5 custom-border mx-auto bg-slate-900 mb-12 mt-6">
            <div
              key={question.id}
              className="text-center text-lg  questions mt-2 text-white"
            >
              {question.question
                ? question.question.slice(3, -4)
                : "question.question"}
            </div>
            <div>
              <div className="">
                <Quiz key={question.id} question={question}></Quiz>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReactQuiz;
